<template>
  <b-container class="edit-group">
    <breadcrumb v-if="addOrEdit == 'Edit '" level="group"></breadcrumb>
    <div id="group">
      <h1 class="title">{{ addOrEdit }} Group</h1>
      <div id="alert">
        <b-alert
          :show="dismissCountDown"
          dismissible
          variant="success"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
          >You have successfully {{ addOrEdit }} group!</b-alert
        >
        <b-alert :show="showError" dismissible variant="warning"
          >Something went Wrong. Please refresh and try again.</b-alert
        >
      </div>
      <b-row>
        <b-col>
          <active-input plural="groups" singular="group"></active-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h4 class="sub-title">Basic Information</h4>
          <div class="basic-group-info mt-4">
            <b-form-group>
              <label for="group-name">Group Name:</label>
              <b-form-input type="text" v-model="group_name"></b-form-input>
            </b-form-group>
            <b-form-group>
              <label for="description">Group Description:</label>
              <b-form-textarea
                type="text"
                name="description"
                v-model="description"
              ></b-form-textarea>
            </b-form-group>
            <group-trainer :parent="addOrEdit"></group-trainer>
          </div>
        </b-col>
        <b-col>
          <h4 class="sub-title">Geographic Information</h4>
          <geo-info
            plural="groups"
            parent="group"
            singular="group"
            :coords="false"
          ></geo-info>
          <br />
          <group-type></group-type>
        </b-col>
      </b-row>
      <b-row></b-row>
      <b-row>
        <b-col>
          <group-dates></group-dates>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h4 class="sub-title m-4">Group Teachers</h4>
          <group-teachers></group-teachers>
        </b-col>
      </b-row>
      <br />
      <confirm-submit v-if="isAdmin || isSRC"></confirm-submit>
      <b-button
        v-if="isAdmin || isSRC"
        :size="'lg'"
        :variant="'primary'"
        class="app_group_btn mb-4"
        @click.prevent="submitData"
        :disabled="isDisabled"
        >{{ addOrEdit }} Group</b-button
      >
    </div>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ConfirmSubmit from "../components/ConfirmSubmit";
import GeoInfo from "../components/GeoInfo";
import GroupTrainer from "../components/GroupTrainer";
import ActiveInput from "../components/ActiveInput";
import GroupTeachers from "../components/GroupTeachers";
import GroupDates from "../components/GroupDates";
import GroupType from "../components/GroupType";
import { flash } from "@/mixins/flashes";
import { scrollTo } from "@/mixins/scrollTo";
import Breadcrumb from "@/components/Breadcrumb";

export default {
  name: "EditGroup",
  mixins: [flash, scrollTo],
  components: {
    ConfirmSubmit,
    GeoInfo,
    ActiveInput,
    GroupTeachers,
    GroupTrainer,
    GroupDates,
    GroupType,
    Breadcrumb
  },
  data() {
    return {
      isDisabled: false,
      showError: false,
      selectCurrent: false,
      selectPrevious: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismissParentCountDown: 0
    };
  },
  methods: {
    ...mapActions({
      GET_ONE_GROUP: "groups/GET_ONE_GROUP",
      UPDATE_GROUP: "groups/UPDATE_GROUP",
      CREATE_GROUP: "groups/CREATE_GROUP",
      RESET_GROUPS_STATE: "groups/RESET_GROUPS_STATE"
    }),
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    flashSuccess() {
      this.dismissCountDown = this.dismissSecs;
    },
    flashError() {
      this.showError = !this.showError;
    },
    async submitData() {
      if (this.$route.params && this.$route.params.id) {
        await this.UPDATE_GROUP();
        window.scrollTo(0, 0);
        this.flashSuccess();
      } else {
        if (!this.group_name.length) {
          alert("please add a group name");
          return;
        }
        await this.CREATE_GROUP();
        window.scrollTo(0, 0);
        this.$store.commit("resetConfirmed");
        this.flashSuccess();
        this.RESET_GROUPS_STATE();
      }
    }
  },
  stopClick() {},
  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin",
       isSRC: "auth/isSRC",
    }),
    addOrEdit() {
      return this.$route.path.includes("/add") ? "Add a " : "Edit ";
    },
    group_name: {
      get() {
        return this.$store.state.groups.group.group_name;
      },
      set(val) {
        this.$store.commit("groups/group_name", val);
      }
    },
    description: {
      get() {
        return this.$store.state.groups.group.description;
      },
      set(val) {
        this.$store.commit("groups/description", val);
      }
    }
  },
  created() {
    this.RESET_GROUPS_STATE();
  },
  mounted() {
    if (!this.$route.path.includes("/add")) {
      this.GET_ONE_GROUP();
    }
  },
  destroyed() {
    this.RESET_GROUPS_STATE();
  }
};
</script>

<style scoped>
#edit-group {
  width: 98%;
  white-space: nowrap;
  margin: 0 auto;
  text-align: center;
}
form input,
.form div {
  margin: 20px;
}
.app_group_btn {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: 520px;
  border: none;
  cursor: pointer;
}
div.col {
  margin: 1%;
  padding: 1%;
  border: 1px solid gray;
  box-shadow: 3px 2px 2px #b2b2b2;
}
</style>
